export const CLIENT_MODULE = 'CLIENT';
export const SYSTEM_MODULE = 'SYSTEM';
export const GUEST_MODULE = 'GUEST';
export const USER_MODULE = 'USER';
export const ROLE_MODULE = 'USER_ROLE_MODULE';
export const DASHBOARD_MODULE = 'DASHBOARD_MODULE';
export const PARKING_METER_MODULE = 'PARKING_METER_MODULE';
export const NOTIFICATION = 'NOTIFICATION';
export const CAMERA_MODULE = 'CAMERA_MODULE';
